import { fetchData } from "./fetchData";

//get user's poi group info (for a specific job)
export const getUsersPOIGroupsAPI = async(jobId) => {
    const route = `/pois/groups/users?jobid=${jobId}`;

    const options = {
        method: 'GET'
    }

    let response = await fetchData(route, options);

    return response;
}

//get users in a poi group
export const getPOIGroupUsersAPI = async(poiGroupId) => {
    const route = `/pois/groups/${poiGroupId}/users`;

    const options = {
        method: 'GET',
    }

    let response = await fetchData(route, options);

    return response;
}

//add users to a poi group (an array of user ids)
export const addUsersToPOIGroupAPI = async(poiGroupId, users) => {
    const route = `/pois/groups/${poiGroupId}/users`;

    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({users})
    }

    let response = await fetchData(route, options);

    return response;
}

//remove users from a poi group (an array of user ids)
export const removeUsersFromPOIGroupAPI = async(poiGroupId, userIds) => {
    const route = `/pois/groups/${poiGroupId}/users`;

    const options = {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({userIds})
    }

    let response = await fetchData(route, options);

    return response;
}

export const updatePOIGroupUsersAPI = async(poiGroupId, users) => {
    const route = `/pois/groups/${poiGroupId}/users`;

    const options = {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({users})
    }

    let response = await fetchData(route, options);

    return response;
}

//get user's poi group info (for a specific job)
export const getUsersPOIsAPI = async(jobId) => {
    const route = `/pois/users?jobid=${jobId}`;

    const options = {
        method: 'GET',
    }

    let response = await fetchData(route, options);

    return response;
}